// extracted by mini-css-extract-plugin
export default {"header":"RenameRouteModal_header__cX3qv","buttonContainer":"RenameRouteModal_buttonContainer__PbttA"};